
import axios from "axios";
import getIntervalParams from "../../common/Helper/getIntervalParams";

import CryptoJS from "crypto-js";
import { handleLogout } from "./getRequest";

// Helper function to format date
const formatDate = (isoDate) => {
  const date = new Date(isoDate);
  const formattedDate = date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  return formattedDate.replace(/\//g, "/"); // Convert to MM-DD-YYYY
};

export const getOperationData = async (query) => {
  let result = {};
  // console.log("query", query);

  console.log("[getOperationData] Raw query received:", query);

  const params = getIntervalParams(
    query.name,
    query?.startDate,
    query?.endDate,
  );
  params.limit = query?.limit;
  const searchParams = new URLSearchParams(params).toString();

  console.log("[getOperationData] Params built:", params);
  console.log("[getOperationData] URL searchParams string:", searchParams);
  console.log("[getOperationData] Full API URL:", `${process.env.REACT_APP_GET_OPERATION_HOME_API}&${searchParams}`);

  const SECRET_KEY = "1234567890abcdef1234567890abcdef";

  function decryptFunction(ciphertext, key) {
    try {
      // Decrypt
      let bytes = CryptoJS.AES.decrypt(ciphertext, key);
      let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      return decryptedData;
    } catch (error) {
      console.log("error", error);
      return ciphertext;
    }
  }
  const authToken = localStorage.getItem("authToken");
  console.log("authToken", authToken);
  let response;

  try {
    response = await axios.get(
      `${process.env.REACT_APP_GET_OPERATION_HOME_API}&${searchParams}`,
      { headers: { Authorization: `Bearer ${authToken}` } },
    );
  } catch (error) {
    if (error.status === 401) {
      console.log("Token expired");
      handleLogout();
      return;
    }
    throw error;
  }

  console.log("me here: ", response.status);
  const decrypteddata = decryptFunction(response.data, SECRET_KEY);
  console.log("sertet", decrypteddata);
  console.log("[getOperationData] datafound:", decrypteddata?.datafound);
  console.log("[getOperationData] data length:", decrypteddata?.data?.length);
  console.log("[getOperationData] totalRows:", decrypteddata?.totalRows);

  // return decrypteddata;
  if (response.status === 200) {
    if (decrypteddata.datafound === false) {
      result = {
        tableData: [],
        cardData: {
          calls: 0,
          duration: {
            hour: 0,
            minute: 0,
            second: 0,
          },
          open: 0,
          in_progress: 0,
          closed: 0,
          VMopen: 0,
          VMinProgress: 0,
          VMclosed: 0,
          VMClosedStatus: { high: 0, medium: 0, low: 0 },
          VMInProgressStatus: { high: 0, medium: 0, low: 0 },
          VMOpenStatus: { high: 0, medium: 0, low: 0 },
          ClosedStatus: { high: 0, medium: 0, low: 0 },
          InProgressStatus: { high: 0, medium: 0, low: 0 },
          OpenStatus: { high: 0, medium: 0, low: 0 },
          // urgencyVMClosed: { high: 0, medium: 0, low: 0 },
          // urgencyVMOpen: { high: 0, medium: 0, low: 0 },
          // urgencyVMinProgress: { high: 0, medium: 0, low: 0 },
        },
        totalDataCount: 0,
      };
    } else {
      const {
        data,
        closed,
        duration,
        inProgress,
        open,
        VMopen,
        VMinProgress,
        VMclosed,
        totalCalls,
        pageLimit,
        totalRows,
        OpenStatus,
        InProgressStatus,
        ClosedStatus,
        VMClosedStatus,
        VMInProgressStatus,
        VMOpenStatus,
      } = decrypteddata;

      // Format engagementDate for each item in the tableData
      const formattedData = data.map((item) => ({
        ...item,
        // engagementDate: formatDate(item.engagementDate) // Format the engagementDate
      }));

      result = {
        tableData: formattedData, // Use the formatted data
        cardData: {
          calls: totalCalls,
          duration: {
            hours: duration?.hours,
            minutes: duration?.minutes,
            seconds: duration?.seconds,
          },
          open,
          in_progress: inProgress,
          closed,
          VMopen,
          VMinProgress,
          VMclosed,
          OpenStatus,
          InProgressStatus,
          ClosedStatus,
          VMClosedStatus,
          VMInProgressStatus,
          VMOpenStatus,
        },
        totalDataCount: totalRows,
        limit: pageLimit,
      };
    }
  } else {
    console.log("*** unable to fetch data");
  }
  console.log("result", result);

  return result;
};
